var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import WalletBar from '../../parts/WalletBar.vue';
import { getAccountHttp } from "../../../lib/nisUtils";
import { Address } from "nem-library";
import { WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { ToolBar, WalletBar },
    name: "WalletDetail",
    props: {
        id: String
    },
    data() {
        return {
            loading: true,
            walletType: '',
            walletStructure: '',
            importance: 0,
            publicKey: this.$t('common.not_get'),
        };
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const accountHttp = getAccountHttp();
            const wallet = yield WalletsHelper.get(this.id);
            if (wallet === null) {
                return;
            }
            const address = new Address(wallet.address);
            // check the address is newbie
            accountHttp.getFromAddress(address).subscribe(accountInfoWithMetaData => {
                if (accountInfoWithMetaData.cosignatories.length > 0) {
                    this.walletType = 'Multisig';
                    //this.walletStructure = `${accountInfoWithMetaData.cosignatoriesCount} of ${accountInfoWithMetaData.cosignatories.length}`;
                    // FIXME: multisiginfo is not correct now.
                    // https://github.com/aleixmorgadas/nem-library-ts/issues/38
                    this.walletStructure = '? of ?';
                }
                else {
                    this.walletType = 'Standard';
                    this.walletStructure = '0 of 0';
                }
                this.importance = accountInfoWithMetaData.importance;
                this.publicKey = accountInfoWithMetaData.publicAccount.publicKey;
                this.loading = false;
            }, error => {
                // Error occurs when the account public key is null.
                // This means the account is not multi signature account.
                this.walletType = 'Standard';
                this.walletStructure = '0 of 0';
                this.importance = 0;
                this.publicKey = this.$t('common.not_get');
                this.loading = false;
            });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletDetail.vue
// module id = 637
// module chunks = 1